import React, { useEffect } from "react";

import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { MainContainer } from "./App.style";
import { AppWrapper } from "./App.style";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Loader from "../../components/Loader/Loader";
import ForgotPassword from "../ForgotPassword/ForgotPassword";
import ResetPassword from "../ResetPassword/ResetPassword";
import { AppContextProvider } from "./AppContextProvider";
import Home from "../Home/Home";
import Login from "../Login/Login";
import Logout from "../Logout/Logout";
import Validate from "../Validate/Validate";
import Crediting from "../Crediting/Crediting";
import Transactions from "../Transactions/Transactions";
import ViewProfile from "../UserProfile/UserProfile";
import { useAuth } from "../../providers/Auth";
import PrivateRoute from "../../components/PrivateRoute/PrivateRoute";
import PageNotFound from "../../components/PageNotFound/PageNotFound";
import TwoFaLogin from "../TwoFaLogin/TwoFaLogin";


function App() {
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const admin = auth?.user?.authorities.find(authority => authority === "pactool_admin");
    if (!auth?.loading && auth?.user === undefined) {
      navigate("/", {
        state: {
          showAlert: true,
          severity: "error",
          message: "NOT AUTHORIZED!"
        }
      });
    }
    if (admin === undefined && location.pathname === '/crediting')
    {
      navigate("/home");
    }
  }, [navigate, auth, location]);

  return (
    <AppWrapper className="App">
      { auth?.loading && <Loader showText={false} />}
      <AppContextProvider>
        <Header />
        <MainContainer className="App">
          <Routes>
            <Route path="*" element={<PageNotFound />} />
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/confirm-login" element={<TwoFaLogin />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/home" element={<PrivateRoute />}>
              <Route path="" element={<Home />} />
            </Route>
            <Route path="/validate" element={<PrivateRoute />}>
              <Route path="" element={<Validate />} />
            </Route>
            <Route path="/crediting" element={<PrivateRoute />}>
              <Route path="" element={<Crediting />} />
            </Route>
            <Route path="/transactions" element={<PrivateRoute />}>
              <Route path="" element={<Transactions />} />
            </Route>
            <Route path="/user-profile" element={<PrivateRoute />}>
                <Route path="" element={<ViewProfile />} />
            </Route>
          </Routes>
        </MainContainer>
        <Footer />
      </AppContextProvider>
    </AppWrapper>
  );
}

export default App;
